import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faChevronDown } from "@fortawesome/free-solid-svg-icons";

const SuperVisorSearch = () => {

   

    return (
        <div className="flex items-center space-x-4 w-full">
            <div className="flex items-center h-10 rounded-md border border-gray-300 bg-white px-4 flex-grow">
                <FontAwesomeIcon icon={faSearch} className="text-gray-500 mr-2" />
                <input
                    type="text"
                    placeholder="Search employees..."
                    className="w-full bg-transparent outline-none text-gray-700"
                />
            </div>
           
        </div>
    );
};

export default SuperVisorSearch;
